import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Typography,
  TextField,
  FormControl,
  Button,
  TextFieldProps,
  Autocomplete,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import styles from "../../styles/common/filterAccordion.module.css";
import { useEffect, useState } from "react";
import { useAllFundNames } from "../../lib/hooks";

interface Props {
  setFundData: Function;
  showFund: boolean;
  fund_id?: number;
}
const max: number = 999999999999999999;

const ChallengeFilter = (props: Props) => {
  const [fund_id, setFund_id] = useState<any[]>(
    Number.isNaN(props.fund_id) ? [] : [props.fund_id]
  );
  console.log(fund_id);
  const [proposalMin, setProposalMin] = useState<any>(0);
  const [proposalMax, setProposalMax] = useState<any>(max);
  const [amountMin, setAmountMin] = useState<any>(0);
  const [amountMax, setAmountMax] = useState<any>(max);
  const [proposalNumber, setProposalNumber] = useState<string>(
    "[0," + max.toString() + "]"
  );
  const [challengeAmount, setChallengeAmount] = useState<string>(
    "[0," + max.toString() + "]"
  );

  const rangeToString = (min: number, max: number) => {
    return "[" + min.toString() + "," + max.toString() + "]";
  };

  let {
    loading: fundNameLoading,
    allFundNames,
    error: fundNamError,
  } = useAllFundNames();

  const [subscribe, setSubscribe] = useState(false);

  useEffect(() => {
    if (subscribe) {
      props.setFundData({
        fundData: fund_id.length === 0 ? "All" : fund_id.map((item) => item.id),
        challenge_amount: challengeAmount,
        number_of_proposals: proposalNumber,
      });
    }
    setSubscribe(true);
    // eslint-disable-next-line
  }, [fund_id, challengeAmount, proposalNumber]);

  //handle challenge amount change
  const challengeAmoutnHandler = (event: any) => {
    event.preventDefault();
    setChallengeAmount(rangeToString(amountMin, amountMax));
  };

  // handle number of proposals change
  const numProposalHandler = (event: any) => {
    event.preventDefault();
    setProposalNumber(rangeToString(proposalMin, proposalMax));
  };

  const fundOption =
    !fundNameLoading && fundNamError === null
      ? allFundNames.map((item) => {
          return {
            label: item.fund_name,
            id: item.fund_id,
          };
        })
      : [];

  return (
    <div className={styles.div}>
      <Grid container className={styles.filterGrid}>
        <Grid item>
          <Typography variant="h5">Filter</Typography>
        </Grid>
      </Grid>

      {props.showFund && (
        <Accordion className={styles.accordion} elevation={0}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Fund</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Autocomplete
              // autoComplete
              multiple={true}
              id="combo-box-demo"
              options={fundOption}
              size={"small"}
              onChange={(event: any, newValue: any[] | null) => {
                // setValue(newValue);
                setFund_id(newValue as any[]);
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              // filterSelectedOptions
              // disableClearable
              value={fund_id}
              renderInput={(
                params: JSX.IntrinsicAttributes & TextFieldProps
              ) => <TextField {...params} label="Select Funds" />}
            />
          </AccordionDetails>
        </Accordion>
      )}

      <Accordion className={styles.accordion} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Challenge Amount</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={challengeAmoutnHandler}>
            <FormControl
              size="small"
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "5px",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <TextField
                type="number"
                id="outlined-basic"
                label="Min"
                variant="outlined"
                size="small"
                name="min"
                onChange={(event) => {
                  event.target.value
                    ? setAmountMin(event.target.value)
                    : setAmountMin(0);
                }}
              />
              <TextField
                type="number"
                id="outlined-basic"
                label="Max"
                variant="outlined"
                size="small"
                name="max"
                onChange={(event) => {
                  event.target.value
                    ? setAmountMax(event.target.value)
                    : setAmountMax(max);
                }}
              />
              <Button variant="contained" type="submit">
                Submit
              </Button>
            </FormControl>
          </form>
        </AccordionDetails>
      </Accordion>

      <Accordion className={styles.accordion} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Number of Proposals</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <form onSubmit={numProposalHandler}>
            <FormControl
              size="small"
              sx={{
                display: "flex",
                flexDirection: "row",
                gap: "5px",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <TextField
                type="number"
                id="outlined-basic"
                label="Min"
                variant="outlined"
                size="small"
                name="min"
                onChange={(event) => {
                  event.target.value
                    ? setProposalMin(event.target.value)
                    : setProposalMin(0);
                }}
              />
              <TextField
                type="number"
                id="outlined-basic"
                label="Max"
                variant="outlined"
                size="small"
                // sx={{ mt: "8px" }}
                name="max"
                onChange={(event) => {
                  event.target.value
                    ? setProposalMax(event.target.value)
                    : setProposalMax(max);
                }}
              />
              <Button variant="contained" type="submit">
                Submit
              </Button>
            </FormControl>
          </form>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default ChallengeFilter;
